"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssertionError_1 = require("../error/AssertionError");
const EtudeError_1 = require("../error/EtudeError");
const Direction_1 = require("./Direction");
class Mode {
    constructor(stepPattern) {
        this.stepPattern = stepPattern;
        ++Mode.size;
        Mode._values.push(this);
        this.ascending = stepPattern.slice();
        this.descending = stepPattern.slice().reverse().map(a => -a);
    }
    static values() {
        return Mode._values.slice();
    }
    ordinal() {
        return Mode._values.indexOf(this);
    }
    static valueOf(modeString) {
        const mode = Mode[modeString];
        if (mode instanceof Mode) {
            return mode;
        }
        throw EtudeError_1.default.forInvalid(Mode, modeString);
    }
    toString() {
        return Object.keys(Direction_1.default).find(d => Direction_1.default[d] === this);
    }
    getStepPattern(direction = Direction_1.default.DEFAULT) {
        switch (direction) {
            case Direction_1.default.ASCENDING: return this.ascending.slice();
            case Direction_1.default.DESCENDING: return this.descending.slice();
            default: throw new AssertionError_1.default("Invalid direction");
        }
    }
}
Mode.size = 0;
Mode._values = [];
Mode.IONIAN = new Mode([2, 2, 1, 2, 2, 2, 1]);
Mode.DORIAN = new Mode([2, 1, 2, 2, 2, 1, 2]);
Mode.PHRYGIAN = new Mode([1, 2, 2, 2, 1, 2, 2]);
Mode.LYDIAN = new Mode([2, 2, 2, 1, 2, 2, 1]);
Mode.MIXOLYDIAN = new Mode([2, 2, 1, 2, 2, 1, 2]);
Mode.AEOLIAN = new Mode([2, 1, 2, 2, 1, 2, 2]);
Mode.LOCRIAN = new Mode([1, 2, 2, 1, 2, 2, 2]);
exports.default = Mode;
